import "./polyfills";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import Router from "./router";
import initStore from "./redux";
import { LicenseManager } from "ag-grid-enterprise";

import "./styles/styles.scss";
import { handlePopupReposition } from "./utils/scrollUtil";

LicenseManager.setLicenseKey(
    "Using_this_{AG_Grid}_Enterprise_key_{AG-069897}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Korea_Securities_Lending}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Tru}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Tru}_need_to_be_licensed___{Tru}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{30_December_2025}____[v3]_[01]_MTc2NzA1MjgwMDAwMA==fba73e89f45ec6a4a61beee96465f747"
);

export const store = initStore();

document.addEventListener("scroll", handlePopupReposition);

const root = ReactDOM.createRoot(document.getElementById("root"));
const hash = process.env.REACT_APP_GIT_HASH;
window.__GIT_HASH__ = hash;

// A failed lazy-chunk load means the served build changed under this tab (old
// chunk hashes 404 on the newly deployed pod). Signal the update banner so the
// user is prompted to reload instead of landing on a broken view.
const isChunkLoadError = (err) =>
    !!err &&
    (err.name === "ChunkLoadError" ||
        /Loading chunk [\w-]+ failed/i.test(err.message || ""));
window.addEventListener("error", (evt) => {
    if (isChunkLoadError(evt.error)) {
        window.dispatchEvent(new Event("app:update-available"));
    }
});
window.addEventListener("unhandledrejection", (evt) => {
    if (isChunkLoadError(evt.reason)) {
        window.dispatchEvent(new Event("app:update-available"));
    }
});

// Expose Redux store for e2e test debugging (Playwright/Selenium).
// Only on localhost and dev/qa environments (the environment is the
// second hostname segment: <cpty>.<environment>.truweb.io — "dev",
// "devnaver", "qa", ...). Production domains never match.
const current_domain = window.location.hostname.toLowerCase().split(".");
if (
    current_domain.includes("localhost") ||
    (current_domain[1] || "").startsWith("dev") || current_domain[1] === "qa"
) {
    window.__store__ = store;
}

// Dev-only component preview: render a single real page component with mock data (no
// backend/auth), for fast layout iteration. Dead in production (REACT_APP_PREVIEW unset).
if (process.env.REACT_APP_PREVIEW) {
    // eslint-disable-next-line global-require
    require("./preview/mount").mountPreview(root, process.env.REACT_APP_PREVIEW);
} else {
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <Router />
            </Provider>
        </React.StrictMode>
    );
}
